import api from './api';
import { Gallery, PaginatedResponse } from '../types';

interface GalleryFilters {
  search?: string;
  isPublic?: boolean;
  page?: number;
  limit?: number;
}

export interface GalleryImageInput {
  imageUrl: string;
  title?: string;
  description?: string;
  displayOrder?: number;
}

export const galleriesService = {
  async getList(filters: GalleryFilters = {}): Promise<PaginatedResponse<Gallery>> {
    const params = new URLSearchParams();
    
    if (filters.search) params.append('search', filters.search);
    if (filters.isPublic !== undefined) params.append('isPublic', filters.isPublic.toString());
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<Gallery>>('/galleries', { params });
    return response.data;
  },

  async getById(id: number): Promise<Gallery> {
    const response = await api.get<Gallery>(`/galleries/${id}`);
    return response.data;
  },

  async create(data: Omit<Gallery, 'id' | 'createdAt' | 'updatedAt' | 'images'>): Promise<Gallery> {
    const response = await api.post<Gallery>('/galleries', data);
    return response.data;
  },

  async update(id: number, data: Partial<Gallery>): Promise<Gallery> {
    const response = await api.put<Gallery>(`/galleries/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/galleries/${id}`);
  },

  async addImage(galleryId: number, image: GalleryImageInput): Promise<Gallery> {
    const response = await api.post<Gallery>(`/galleries/${galleryId}/images`, image);
    return response.data;
  },

  async removeImage(galleryId: number, imageId: number): Promise<Gallery> {
    const response = await api.delete<Gallery>(`/galleries/${galleryId}/images/${imageId}`);
    return response.data;
  },

  async reorderImages(galleryId: number, imageIds: number[]): Promise<Gallery> {
    const response = await api.put<Gallery>(`/galleries/${galleryId}/images/reorder`, { imageIds });
    return response.data;
  },

  async togglePublic(id: number): Promise<Gallery> {
    const response = await api.post<Gallery>(`/galleries/${id}/toggle-public`);
    return response.data;
  },
};
